export const getRib = state => state.rib.cotisation.data
export const isRibLoading = state => state.rib.cotisation.loading
export const getCache = state => state.rib.cotisation.cache
